import { motion } from 'framer-motion';
import './styles.css';

export const PageBanner = ({ title, imagePath }: { title: string; imagePath: string }) => {
    return (
        <motion.div className="pageBanner" style={{ backgroundImage: `url(${imagePath})` }}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{ duration: 0.6, ease: "easeOut" }}>
            <div>
                <h1>{title}</h1>
            </div>
        </motion.div>
    );
};

export default PageBanner;
